import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';
import { filter, Subscription } from 'rxjs';
import { NavComponent } from "./components/distinct-components/navigation/nav/nav.component";
import { AdminNavComponent } from './components/distinct-components/navigation/admin-nav/admin-nav.component';
import { CommonModule } from '@angular/common';
import { AppStateService } from './services/app-state.service';
import { UserService } from './services/user.service';
import { NavLiteComponent } from "./components/distinct-components/navigation/nav-lite/nav-lite.component";
import { SubscriptionService } from './services/subscriptions.service';
import { AnalyticsService } from './services/analytics.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavComponent, AdminNavComponent, CommonModule, NavLiteComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'tailOne';
  private routeSubscription!: Subscription;
  private profileSubscription!: Subscription;
  routeType: string = null;
  showNav: boolean = false;
  showNavLite: boolean = false;

  constructor(
    public authService: AuthService,
    private router: Router,
    private appState: AppStateService,
    private userService: UserService,
    private subscriptionService: SubscriptionService,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    document.body.classList.add(localStorage.getItem('app-theme') || 'dark-theme');
    this.analyticsService.start();

    const hideNavRoutes = ['/login', '/register', '/initialize', '/onboard', '/forgot', '/reset'];

    this.profileSubscription = this.userService.userProfile$.subscribe(async user => {
      this.appState.user.profile.set(user);
      if (user) {
        try {
          const subscription = await this.subscriptionService.getSubscriptionInfo();
          this.appState.user.subscription.set(subscription);
          const entitlement = await this.subscriptionService.getEntitlementState(user, { subscription });
          this.appState.user.entitlement.set(entitlement);
        } catch (err) {
          console.error(err); // TODO: friendly
        }
      } else {
        this.subscriptionService.clearCache();
        this.appState.user.subscription.set(null);
        this.appState.user.entitlement.set(null);
      }
    });

    this.routeSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;

        this.routeType = url.includes('/admin') ? 'admin' : 'user';
        this.showNav = !hideNavRoutes.some(path => url.includes(path));
        this.showNavLite = url.includes('/onboard');

        if (!url.startsWith('/agent') && this.appState.agent.mode() !== 'agent') {
          this.appState.agent.mode.set('agent');
        }

        this.appState.navigation.currentURL.set(url);
        this.appState.navigation.backButtonState.set(null);
      });
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.profileSubscription.unsubscribe();
  }
}
